// extracted by mini-css-extract-plugin
export default {"root":"Burger_root__-SfZ5","item":"Burger_item__rE7Qn","active":"Burger_active__vKL8F"};